import React from 'react';
import { SonarTagDisplay } from '@ui/tags';
import { Space } from 'antd';
import { useSonarObjectReference } from '@hooks';

export interface TagsColumnProps {
	sonarObjectId: number;
}

export const TagsColumn: React.FC<TagsColumnProps> = ({ sonarObjectId }) => {
	const tagIds = useSonarObjectReference(sonarObjectId)?.tagIds ?? [];

	return (
		<Space
			size={ 4 }
			wrap>
			{ tagIds.map((id) =>
				<SonarTagDisplay
					key={ `${id}-tag` }
					tagId={ id } />) }
		</Space>
	);
};
